import type { PrescriptionFieldKey } from '@/entities/rx';

/** Core ``PrescriptionT`` keys rendered in refill and RxChange detail cards. */
export const PRESCRIPTION_DETAIL_FIELDS: ReadonlyArray<PrescriptionFieldKey> = [
  'Quantity',
  'Refills',
  'DaysSupply',
  'Directions',
  'PharmacyId',
];

/** Core keys plus the dates the refill surface shows. */
export const REFILL_PRESCRIPTION_FIELDS: ReadonlyArray<PrescriptionFieldKey> = [
  ...PRESCRIPTION_DETAIL_FIELDS,
  'EffectiveDate',
  'WrittenDate',
];
